"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const react_1 = __importDefault(require("react"));
const Toggle_style_1 = require("./Toggle.style");
const Toggle = ({ isChecked, onChange, noLabel = false, labelLeft, labelRight, biggerMobileVersion = false, variant, }) => {
    const handleClick = () => {
        onChange(!isChecked);
    };
    return (react_1.default.createElement(Toggle_style_1.ToggleContainer, { onClick: handleClick },
        !noLabel && (react_1.default.createElement(Toggle_style_1.Label, { "$isActive": !isChecked && variant === "switch" }, labelLeft)),
        react_1.default.createElement(Toggle_style_1.ToggleLabel, { "$biggerMobileVersion": biggerMobileVersion },
            react_1.default.createElement(Toggle_style_1.ToggleInput, { type: "checkbox", checked: isChecked, onChange: handleClick, "$biggerMobileVersion": biggerMobileVersion }),
            react_1.default.createElement(Toggle_style_1.Slider, { "$isActive": isChecked, "$variant": variant, "$biggerMobileVersion": biggerMobileVersion })),
        variant === "switch" && labelRight && (react_1.default.createElement(Toggle_style_1.Label, { "$isActive": isChecked }, labelRight))));
};
exports.Toggle = Toggle;
